import React from 'react';
import loadable from '@loadable/component';
import Loader from 'components/Loader';

const BookingDetails = loadable(() => import(/* webpackChunkName: "BookingDetails" */ './Details'), {
  fallback: <Loader visible />,
});

export default BookingDetails;
